import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { timeStamp } from 'console';
import { RequestModel } from '../../../models/request/request-model';
import { SemTextBoxComponent } from '../sem-text-box/sem-text-box.component';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';

@Component({
    selector: 'sem-ajpes-text-box',
    templateUrl: './sem-ajpes-input-control.component.html',
    styleUrls: ['./sem-ajpes-input-control.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: SemAjpesInputControl, multi: true }
    ],
    standalone: false
})

export class SemAjpesInputControl extends ValueAccessorBase<string> implements OnInit {

  @Input() afterResultEvalScript: string = "";
  @Input() apiUrl: any = "";
  @Input() maxLength: any = "";
  @Input() isPostNumber: boolean = false;
  loadingResults: boolean = false;

  super() { }

  ngOnInit() {
    super.ngOnInit();
  }

  onTextChange(event:Event) {

    const input = event.target as HTMLInputElement;
    
    const cursorPosition = input.selectionStart;

    /*
      Prevent any non-digit character because ->
      Valid Characters in <input type="number">:

      Digits (0-9): These are obviously allowed.
      Decimal point (.): Used for floating-point numbers.
      Negative sign (-): To allow negative numbers.
      Positive sign (+): Although usually optional, this can also be used.
      The letter "e": Used to indicate the exponent in scientific notation.
    */
    /*if (!/^[0-9]$/.test(input.value)) {
      input.value = input.value.replace(/[^0-9]/g, '');      
    }*/

    if (!/^[0-9]+$/.test(input.value)) { 
      input.value = input.value.replace(/[^0-9]/g, ''); 
    }
    

    // Restore cursor position to where the user was typing
    if (cursorPosition !== null) {
      input.setSelectionRange(cursorPosition, cursorPosition);
    }

    if (input.value.length > this.maxLength) {
      input.value = input.value.slice(0, this.maxLength);
      return;
    }

    if (input.value.length == this.maxLength && this.apiUrl && this.apiUrl.length > 0) {
      this.loadingResults = true;
      this.restProviderService.getDataGET(this.apiUrl + input.value).subscribe((data: any) => {
        try {

          this.loadingResults = false;
          let dataJson = {};

          if(!this.isPostNumber){
            dataJson = JSON.parse(data);
          }

          eval(this.afterResultEvalScript);

          /*this.model.Company.CompanyName = dataJson.FullName;
          this.model.Company.Address = dataJson.AddressStreet + " " + dataJson.AddressNumber;
          this.model.Company.PostOfficeNumber = dataJson.AddressPost;
          this.model.Company.City = dataJson.AddressTown;*/

        } catch (e) {
          console.log(e);
        }

      }, error => {
        console.log(error);
        this.loadingResults = false;
      });
    }



    this.checkAfterInput(input.value);
  }

  checkAfterInput(value) {
    let attName = this.getAttribute("name");

    let control = this.dfms.globalForm.controls[attName];

    if (control !== null && typeof control !== "undefined") {
      this.dfms.globalForm.controls[attName].setValue(value);
      this.dfms.globalForm.controls[attName].updateValueAndValidity();
    }


    this.dfms.updateControlsValidationArray(attName, value);

    if (typeof this.onValueChangeEval != "undefined" && this.onValueChangeEval) {
      eval(this.onValueChangeEval);
    }
  }
}
